import { CommonBlock } from 'types/blocks';
import { makeId } from 'utils/common';

export function assignOriginalIdToBlocks<T extends CommonBlock>(blocks: T[] = []): T[] {
  return blocks.map((block) => ({
    ...block,
    originalId: block.originalId ?? parseInt(makeId(8, { letters: false })),
  }));
}
